import {
  StrictMode,
} from "react"

import {
  createRoot,
} from "react-dom/client"

import {
  CssBaseline,
  ThemeProvider,
} from "@mui/material"

import "./index.css"
import App from "./App.jsx"
import rlsysTheme from "./theme/rlsysTheme"


createRoot(
  document.getElementById(
    "root"
  )
).render(
  <StrictMode>
    <ThemeProvider
      theme={
        rlsysTheme
      }
    >
      <CssBaseline />

      <App />
    </ThemeProvider>
  </StrictMode>
)
